﻿import { SxProps, Theme } from "@mui/material";

export function createSxStyles<T extends Record<string, SxProps<Theme>>>(styles: T) {
    return styles;
}
